import { DeliveryStatus } from '@hooks/types';
import { MediaType } from '@hooks/useAlbumInfo/types';

export interface AlbumSearchResult {
  name: string;
  artistName: string;
  labelName: string;
  licensorName: string;
  originalReleaseDate: string;
  type: string;
  uri: string;
  feedName: string;
  mediaType: MediaType;
  // Optional because existing release view history does not have title versions saved
  // New history items will have title version properties included
  titleVersion?: string;
  deliveryStatus: DeliveryStatus;
  hasAtLeastOneExplicitTrack: boolean;
  primaryReleaseId: string;
  upc: string;
  ean: string;
}

export type StoredSearchResult = Omit<AlbumSearchResult, 'deliveryStatus'>;

export type SearchedAlbumsResponse = {
  searchResults: AlbumSearchResult[];
};

export enum SearchType {
  FREE_TEXT = 'Text Search',
  ALBUM_URI = 'Album URI',
  ARTIST_URI = 'Artist URI',
  TRACK_URI = 'Track URI',
  ALBUM_URL = 'Album URL',
  ARTIST_URL = 'Artist URL',
  BULK_SEARCH = 'Bulk Search',
  TRACK_URL = 'Track URL',
}

enum SortField {
  // SEARCH_SORT_FIELD_UNKNOWN = 'SEARCH_SORT_FIELD_UNKNOWN', // supported by API if needed
  ORIGINAL_RELEASE_DATE = 'ORIGINAL_RELEASE_DATE',
  ALBUM_NAME = 'ALBUM_NAME',
  ARTIST_NAME = 'ARTIST_NAME',
}

enum SortDirection {
  // SEARCH_SORT_DIRECTION_UNKNOWN = 'SEARCH_SORT_DIRECTION_UNKNOWN', // supported by API if needed
  SEARCH_SORT_DIRECTION_ASC = 'SEARCH_SORT_DIRECTION_ASC',
  SEARCH_SORT_DIRECTION_DESC = 'SEARCH_SORT_DIRECTION_DESC',
}

export type SearchSortField = keyof typeof SortField;
export type SearchSortDirection = keyof typeof SortDirection;

export type SearchParams = {
  searchType: SearchType;
  searchTerm: string;
  feedIds: string[];
  licensorIds: string[];
  limit: string;
  page: string;
  searchSortField: SearchSortField;
  searchSortDirection: SearchSortDirection;
};
